import { Component } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { InputComponent } from "../../../shared/input/input.component";
import { ButtonComponent } from "../../../shared/button/button.component";
import { RouterLink } from "@angular/router";
import { LayoutComponent } from "../../../shared/layout/layout.component";
import { TitleComponent } from "../../../shared/title/title.component";
import { GigyaService } from "../../../services/gigya.service";
import { SpinnerComponent } from "../../../shared/icons/spinner/spinner.component";
import { BreadcrumbComponent } from "../../../shared/breadcrumb/breadcrumb.component";

@Component({
  selector: 'app-update-email',
  templateUrl: './update-email.component.html',
  styleUrl: './update-email.component.css',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputComponent,
    ButtonComponent,
    RouterLink,
    LayoutComponent,
    TitleComponent,
    BreadcrumbComponent,
    SpinnerComponent,
  ],
})
export class UpdateEmailComponent {
  emailForm: FormGroup;
  button_clicked: boolean = false;
  submitting: boolean = false;
  error: boolean = false;
  success: boolean = false;

  constructor(
    private fb: FormBuilder,
    private gigyaService: GigyaService,
  ) {
    this.emailForm = this.fb.group({
      newEmail: ["", [Validators.required, Validators.email]],
      confirmEmail: ["", [Validators.required, Validators.email]],
    });
  }

  get emailMismatch(): boolean {
    const newEmail = this.emailForm.get("newEmail")?.value;
    const confirmEmail = this.emailForm.get("confirmEmail")?.value;
    return newEmail && confirmEmail && newEmail !== confirmEmail;
  }

  get currentEmail(): string {
    return (this.gigyaService.data as any)?.profile?.email || "";
  }

  async onSubmit() {
    if (this.emailForm.valid && !this.emailMismatch) {
      const newEmail = this.emailForm.get("newEmail")?.value;

      this.error = false;
      this.success = false;
      this.button_clicked = true;
      this.submitting = true;

      const res = await this.gigyaService.execute(this.gigyaService.client.accounts.setAccountInfo, {
        profile: { email: newEmail },
        addLoginEmails: newEmail,
        removeLoginEmails: this.currentEmail,
      });

      this.submitting = false;
      if (res.errorCode === 0) {
        this.success = true;
        return;
      }
      this.button_clicked = false;
      this.error = true;
    }
  }
}
